import axios from "axios";
import { atom, selectorFamily } from "recoil";

export const loadingState = atom({
  key: "visualize.loadingState",
  default: false,
});

export const icn3dUrlState = atom({
  key: "visualize.icn3dUrlState",
  default: "",
});

export const defaultParams = {
  vcfFile: [],
  limit: 1000,
  gene: "",
  async: false,
  email: "",
  jobName: "",
};

export const formState = atom({
  key: "visualize.formState",
  default: defaultParams,
});

export const paramsState = atom({
  key: "visualize.paramsState",
  default: defaultParams,
});

export const statusState = atom({
  key: "visualize.statusState",
  default: { status: "LOADING" },
});

export const resultsState = atom({
  key: "visualize.resultsState",
  default: [],
});

export function isDone(status) {
  return ["COMPLETED", "FAILED"].includes(status);
}

export async function getParams(id) {
  try {
    if (!id) return defaultParams;
    const endpoint = `${process.env.PUBLIC_URL}/api/data/input/${id}/params.json`;
    const response = await axios.get(endpoint, { params: { t: Date.now() } });
    return response.data;
  } catch (error) {
    console.error(error);
    return defaultParams;
  }
}

export async function getStatus(id) {
  try {
    if (!id) return null;
    const endpoint = `${process.env.PUBLIC_URL}/api/data/output/${id}/status.json`;
    const response = await axios.get(endpoint, { params: { t: Date.now() } });
    return response.data;
  } catch (error) {
    console.error(error);
    return null;
  }
}

export async function getResults(id) {
  try {
    if (!id) return null;
    const endpoint = `${process.env.PUBLIC_URL}/api/data/output/${id}/results.json`;
    var response = await axios.get(endpoint, { params: { t: Date.now() } });
    console.log(response)
    return response.data.sort((a, b) => a.Variant.localeCompare(b.Variant)).map((row, index) => ({ ...row, _id: index }));
  } catch (error) {
    console.error(error);
    return null;
  }
}

export const paramsSelector = selectorFamily({
  key: "visualize.paramsSelector",
  get: (id) => async () => getParams(id),
});

// export const statusSelector = selectorFamily({
//   key: "visualize.statusSelector",
//   get: (id) => async () => getStatus(id),
// });

// export const resultsSelector = selectorFamily({
//   key: "visualize.resultsSelector",
//   get: (id) => async () => getResults(id),
// });
